import { useEffect, useState } from "react";
import "./filter.css";
import FilterLandscape from "./FIlterLandscape";
import FilterPortrait from "./FilterPortrait";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";
import {
  compareAsc,
  format,
  getMonth,
  getYear,
  eachDayOfInterval,
} from "date-fns";

const Filter = ({
  setFilteringChecked,
  setAddingChecked,
  setDetailedChecked,
  location,
  showingItems,
  setShowingItems,
  selectedCompany,
  filterState,
  setFilterState,
  setPdfItems,
  location_input,
  aspectRatio,
}) => {
  const [allData, setAllData] = useState([]);
  const [daysArchive, setDaysArchive] = useState();

  const { loggedUser, apiKey, baseUrl } = useGlobalContext();

  const handleReturn = () => {
    setFilteringChecked(0);
    setAddingChecked(false);
  };

  useEffect(() => {
    const getItems = async () => {
      try {
        axios
          .post(`${baseUrl}/items/getCommentsSeen.php`, {
            location_id: location.location_id,
            location_input: location_input,
            user_id: loggedUser.id,
            api_key: apiKey,
          })
          .then((data) => {
            console.log(data);
            if (data.status === 200) setAllData(data.data.items);
          });
      } catch (error) {
        console.log("Error fetching messages");
      }
    };
    const handleFetchDate = () => {
      try {
        axios
          .post(`${baseUrl}/items/getTimeOfCreation.php`, {
            location_id: location.location_id,
            location_input,
            api_key: apiKey,
          })
          .then((data) => {
            console.log(data);
            if (data.status === 200) {
              setDaysArchive(
                eachDayOfInterval({
                  start: new Date(data.data.start),
                  end: new Date(data.data.end),
                })
              );
            }
          });
        //console.log(response);
      } catch (error) {
        console.log("Error fetching messages");
      }
    };
    getItems();
    handleFetchDate();
  }, []);

  console.log(allData);

  if (aspectRatio)
    return (
      <FilterLandscape
        handleReturn={handleReturn}
        setDetailedChecked={setDetailedChecked}
        allData={allData}
        setShowingItems={setShowingItems}
        daysArchive={daysArchive}
        showingItems={showingItems}
        location={location}
        selectedCompany={selectedCompany}
        filterState={filterState}
        setFilterState={setFilterState}
        setPdfItems={setPdfItems}
        location_input={location_input}
        aspectRatio={aspectRatio}
      />
    );
  else
    return (
      <FilterPortrait
        handleReturn={handleReturn}
        setDetailedChecked={setDetailedChecked}
        allData={allData}
        setShowingItems={setShowingItems}
        daysArchive={daysArchive}
        showingItems={showingItems}
        location={location}
        selectedCompany={selectedCompany}
        filterState={filterState}
        setFilterState={setFilterState}
        setPdfItems={setPdfItems}
        location_input={location_input}
        aspectRatio={aspectRatio}
      />
    );
};

export default Filter;
